import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem, Select } from '@material-ui/core';

import './CustomerLogin.scss';
import Button from 'src/components/Button/Button';
import usePreviousValue from 'src/hooks/usePreviousValue';
import { RootState } from 'src/configs/store';

function CustomerLogin() {
  const { t } = useTranslation();
  const [selectedMethod, setSelectedMethod] = useState(0);
  const [customer, setCustomer] = useState('');
  const [password, setPassword] = useState('');
  const loginSelections = [{ value: 0, label: 'customerCard' }, { value: 1, label: 'customerAccount' }, { value: 2, label: 'customerEmail' } ];

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const code = location.hash.split('=')[1];
  const { authenticated } = useSelector((state: RootState) => state.auth);
  const prevAuthenticated = usePreviousValue(authenticated);
  const passwordRef = useRef(null);

  useEffect(() => {
    if (code){
      setSelectedMethod(1);
      setCustomer(code);
      passwordRef.current.focus();
    }
  }, [code]);

  useLayoutEffect(() => {
    // If logged in, remove hash from url to hide modal.
    if (authenticated && !_.isUndefined(prevAuthenticated)) {
      if (location.hash) {
        history.replace(location.pathname + location.search);
      }

      dispatch.content.modalType('');
    } else if (authenticated && _.isUndefined(prevAuthenticated)) {
      history.replace(`${ location.pathname }#existing-customer${ location.search }`);
    }
  }, [authenticated]);

  const onSubmit = (e) => {
    e.preventDefault();
    let key = 'username';
    if (selectedMethod === 0){
      key = 'cardNumber';
    } else if (selectedMethod === 1){
      key = 'accountNumber';
    }
    dispatch.auth.userByAccount({ [key]: customer, password });
  };

  return (
    <form className="till-login" onSubmit={ onSubmit } autoComplete="new-password">
      <h3 className="till-login__description">{ t('modal.customer-loginTillDescription') }</h3>
      <Select
        className="till-login__select"
        name="method"
        autoComplete="new-password"
        value={ selectedMethod }
        onChange={ (e) => setSelectedMethod(+e.target.value) }
        MenuProps={
          {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            getContentAnchorEl: null
          }
        }
      >
        {
          _.map(loginSelections, (method, index) => <MenuItem key={ index } value={ method.value }>
            { t(`form.${ method.label }`) }
          </MenuItem>)
        }
      </Select>
      <div className="till-login__inputs-container">
        <label className="till-login__input-label">{ t(`form.${ loginSelections[selectedMethod].label }`) }</label>
        <label className="till-login__input-label">{ t('form.retailCustomerPassword') }</label>
        <input
          autoComplete="new-password"
          required
          name={ loginSelections[selectedMethod].label }
          value={ customer }
          className="till-login__input"
          onChange={ (e) => setCustomer(e.target.value) }
        />
        <input
          type="password"
          ref={ passwordRef }
          required
          name="new-password"
          autoComplete="new-password"
          value={ password }
          className="till-login__input"
          onChange={ (e) => setPassword(e.target.value) }
        />
      </div>
      <div className="till-login__link">
        <Link to="/#forgot-password" className="till-login__link">{ t('forgotPassword') }</Link>
      </div>
      <Button type="submit" size="big" className="btn btn--cta till-login__submit modal-submit" text={ t('login') } />
    </form>
  );
}

export default CustomerLogin;
